var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 15V13.4444C14.0909 12.6193 13.7461 11.828 13.1323 11.2446C12.5186 10.6611 11.6862 10.3333 10.8182 10.3333H4.27273C3.40475 10.3333 2.57232 10.6611 1.95856 11.2446C1.3448 11.828 1 12.6193 1 13.4444V15M19 15V13.4444C18.9995 12.7551 18.7581 12.0855 18.3138 11.5407C17.8696 10.9959 17.2476 10.6068 16.5455 10.4344M13.2727 1.10111C13.9767 1.27246 14.6007 1.66166 15.0462 2.20735C15.4918 2.75305 15.7337 3.4242 15.7337 4.115C15.7337 4.8058 15.4918 5.47695 15.0462 6.02265C14.6007 6.56834 13.9767 6.95754 13.2727 7.12889M10.8182 4.11111C10.8182 5.82933 9.35293 7.22222 7.54545 7.22222C5.73798 7.22222 4.27273 5.82933 4.27273 4.11111C4.27273 2.39289 5.73798 1 7.54545 1C9.35293 1 10.8182 2.39289 10.8182 4.11111Z",
    stroke: "currentColor",
    strokeOpacity: 0.6,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.bcad44ef.svg";
export { ForwardRef as ReactComponent };